import Member from 'src/models/Member';

class Room {
  constructor(json = {}) {
    if (!json) {
      json = {};
    }
    this.me = {};
    this.loadFromJson(json);
  }

  loadFromJson(json) {
    this.id = "id" in json ? json.id : null;
    this.showVotes = "showVotes" in json ? json.showVotes : false;
    this.ownerId = "ownerId" in json ? json.ownerId : null;

    this.members = [];
    if ("members" in json && json.members) {
      this.members = Object.values(json.members).map((mJson) => new Member(mJson))
    }
  }
}

export default Room;
